import { IconDownload } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';
import { useGetDocument } from '../SignDocumentStep/useGetDocument';

const PERSONAL_GUARANTEE_PATH = '/funding-requirements/sign-personal-guarantee';

type TPersonalGuaranteeStepProps = { status: TFundingRequirementStatus };

export const PersonalGuaranteeStep = ({
    status
}: TPersonalGuaranteeStepProps) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.personal_guarantee_step.list_title"
                    defaultMessage="Read and sign the Personal Guarantee"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 2 }}
                />
            }
            href={PERSONAL_GUARANTEE_PATH}
            status={status}
            completedView={<PersonalGuaranteeCompletedView />}
        />
    );
};

const PersonalGuaranteeCompletedView = () => {
    const { downloadUrl, isLoading } = useGetDocument('guarantee');

    return (
        <div className="flex grow items-center justify-between gap-l pr-0 min-m:pr-s">
            <Text className="text-m font-med text-primary-10">
                <FormattedMessage
                    id="_.funding_requirements.personal_guarantee_step.list_title"
                    defaultMessage="Read and sign the Personal Guarantee"
                />
            </Text>
            {!isLoading && (
                <a
                    href={downloadUrl}
                    download
                    aria-label="Download personal guarantee"
                    className="text-l text-primary-40"
                >
                    <IconDownload />
                </a>
            )}
        </div>
    );
};
